import { render, staticRenderFns } from "./OrderTreatmentDetails.vue?vue&type=template&id=351f0524"
import script from "./OrderTreatmentDetails.vue?vue&type=script&lang=js"
export * from "./OrderTreatmentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports